import { STANDARD_BLOCK_FIELDS } from "../../lib/formFieldTypes";

/**
 * Renders the switchable "standard information block" (carer name,
 * client name, form date, etc.) — the same 6 optional fields every
 * template can turn on/off and mark required, independently.
 */
export function StandardBlockRenderer({ standardBlock, answers, onChange, mode = "fill" }) {
  if (!standardBlock?.enabled) return null;
  const active = (standardBlock.fields || []).filter((f) => f.enabled);
  if (active.length === 0) return null;
  const printing = mode === "print";

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-4 mb-6" data-testid="standard-block">
      <div className="grid sm:grid-cols-2 gap-4">
        {active.map((f) => {
          const val = answers?.[f.key] || "";
          const isDate = f.key === "form_date";
          const isDateTime = f.key === "completion_datetime";
          if (printing) {
            return (
              <div key={f.key}>
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wide">
                  {f.label}{f.required ? " *" : ""}
                </div>
                <div className="text-sm border-b border-slate-300 min-h-[1.4rem] py-0.5">{val || "\u00A0"}</div>
              </div>
            );
          }
          return (
            <label key={f.key} className="block">
              <span className="text-sm font-medium text-ink">
                {f.label}{f.required && <span className="text-red-600 ml-0.5">*</span>}
              </span>
              <input
                type={isDate ? "date" : isDateTime ? "datetime-local" : "text"}
                value={val}
                disabled={mode === "preview"}
                onChange={(e) => onChange?.(f.key, e.target.value)}
                className="mt-1.5 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-teal focus:ring-1 focus:ring-teal/30"
                data-testid={`standard-block-${f.key}`}
              />
            </label>
          );
        })}
      </div>
    </div>
  );
}

export function defaultStandardBlock() {
  return {
    enabled: false,
    fields: STANDARD_BLOCK_FIELDS.map((f) => ({ key: f.key, enabled: false, required: false, label: f.defaultLabel })),
  };
}
